export default __webpack_public_path__ + "static/media/Ankur.2c983ce6.jpg";